"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    palette: palette,
    background: palette.elLightestHEX,
    borderRadius: palette.gutter / 2 + 'px',
    overflow: 'hidden',
    shapeBackground: "linear-gradient(to right, ".concat(palette.elLightestHEX, ", ").concat(palette.elLightHEX, " 55%, ").concat(palette.elLightestHEX, ")"),
    shapeBackgroundColumn: "linear-gradient(to bottom, ".concat(palette.elLightestHEX, ", ").concat(palette.elLightHEX, " 55%, ").concat(palette.elLightestHEX, ")"),
    shapeHeight: window.screen.availHeight + 'px',
    shapeWidth: window.screen.availWidth + 'px'
  };
}